import React, {useContext} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";


function RealizationTypeData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    const {getDict} = useContext(FormTranslationContext)

    const refersTo = gVal("form.basicData.refersTo", false)
    return (<>
        <Collapse in={refersTo === "Order"}>
            <NoticeGlossaryInput
                id={gId("orderRealizationType")}
                formikProps={formikProps}
                items={getDict("ENUM.018A")}
                required
                disabled={updateNotice}
            />
        </Collapse>
        <Collapse in={refersTo === "FrameworkAgreement"}>
            <NoticeGlossaryInput
                id={gId("frameworkRealizationType")}
                formikProps={formikProps}
                items={getDict("ENUM.019A")}
                required
                disabled={updateNotice}
            />
        </Collapse>
    </>)
}

RealizationTypeData.propTypes = {};

export default RealizationTypeData;
